import * as React from "react";
import BiciComercialContainer from "../containers/seguro-de-bici-comercial-container";

export default function BiciComercialPage({ data }) {
  return <BiciComercialContainer data={data}></BiciComercialContainer>;
}
